// extracted by mini-css-extract-plugin
export default {"container":"Results_container__l5QqK","title":"Results_title__6AuqU","description":"Results_description__X4uPu"};